import { Box, Typography } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { makeStyles } from '@material-ui/styles';
import React, { useRef, useState } from 'react';
import { ActivityFormV2, ActivityFormValues } from './ActivityFormV2';
import { CreateActivityWizard } from './create-activity-wizard/CreateActivityWizard';

type ViewMode = 'steps' | 'list';

const useStyles = makeStyles(() => ({
  toggleGroup: {
    '& .MuiToggleButton-root': {
      padding: '4px 10px',
      border: '1px solid #e0e0e0',
      '&.Mui-selected': {
        backgroundColor: '#7047EB',
        color: '#fff',
        borderColor: '#7047EB',
        '&:hover': {
          backgroundColor: '#5f3cc4',
        },
      },
    },
  },
}));

export const ViewModeToggle = ({
  viewMode,
  onChange,
}: {
  viewMode: ViewMode;
  onChange: (_unusedEvent: React.MouseEvent<HTMLElement>, newValue: ViewMode | null) => void;
}) => {
  const classes = useStyles();
  return (
    <ToggleButtonGroup
      className={classes.toggleGroup}
      value={viewMode}
      exclusive
      size='small'
      onChange={onChange}
      style={{ marginRight: 'auto' }}
    >
      <ToggleButton value='steps'>
        <Typography style={{ fontWeight: 600, fontSize: 11, textTransform: 'none' }}>Steps</Typography>
      </ToggleButton>
      <ToggleButton value='list'>
        <Typography style={{ fontWeight: 600, fontSize: 11, textTransform: 'none' }}>List</Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export const CreateActivityScreenV2 = () => {
  const [viewMode, setViewMode] = useState<ViewMode>('steps');
  const sharedValuesRef = useRef<Partial<ActivityFormValues>>({});

  const handleViewChange = (_unusedEvent: React.MouseEvent<HTMLElement>, newValue: ViewMode | null) => {
    if (newValue !== null) setViewMode(newValue);
  };

  const toggle = <ViewModeToggle viewMode={viewMode} onChange={handleViewChange} />;

  return (
    <Box display='flex' flexDirection='column' height='100%'>
      <Box flex={1} overflow='hidden'>
        {viewMode === 'steps' ? (
          <CreateActivityWizard sharedValuesRef={sharedValuesRef} viewModeToggle={toggle} />
        ) : (
          <ActivityFormV2 predefinedFormValues={sharedValuesRef.current} viewModeToggle={toggle} />
        )}
      </Box>
    </Box>
  );
};
